/**
 * Pure utility functions, constants, and types for the ScriptPreviewSection component.
 */

// ── Types ──────────────────────────────────────────────────────────────────────

export type ScriptPreviewMode = "inbound" | "outbound";

// ── Constants ──────────────────────────────────────────────────────────────────

/**
 * Regex that matches variable placeholders in script text.
 * Format: @[DisplayName](variableId)
 */
export const VARIABLE_REGEX = /@\[([^\]]+)\]\(([^)]+)\)/g;

// ── Helpers ────────────────────────────────────────────────────────────────────

/**
 * Returns the i18n translation key prefix for a given script preview mode.
 */
export function getTranslationPrefix(mode: ScriptPreviewMode) {
  return `configureGail.${mode}.scriptPreview` as const;
}

/**
 * Parse variable placeholders out of a script text string.
 * Returns an array of { display, variableId, index, fullMatch } objects.
 */
export function parseVariables(text: string) {
  const results: { display: string; variableId: string; index: number; fullMatch: string }[] = [];
  const regex = new RegExp(VARIABLE_REGEX.source, VARIABLE_REGEX.flags);
  let match;

  while ((match = regex.exec(text)) !== null) {
    results.push({
      display: match[1],
      variableId: match[2],
      index: match.index,
      fullMatch: match[0],
    });
  }

  return results;
}
